import axios from "axios";

export function updateVoucherSetting({ uuid, enable, method, emailTitle, emailContent, emailImage }) {
  return new Promise((resolve, reject) => {
    axios.post(`/consumer/admin/api/v1/survey/voucher-setting/update`, {
      survey_uuid: uuid,
      is_enabled: enable,
      distribution_method: method,
      email_title: emailTitle,
      email_content: emailContent,
      email_image: emailImage,
    })
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}